export interface DatasourceSyncDetails {
  // Coordinated Universal Time (UTC) with extended fractional seconds -
  // YYYY-MM-DD'T'HH:MM:SS.FFF'Z' e.g: "2024-03-07T15:15:50.058013Z"
  updateTime: string;
  restartTime: string; // same as above
  syncStatus: DatasourceSyncStatus;
  syncProgress: string; // e.g.: '90.00%'
}

export enum DatasourceSyncStatus {
  RUNNING = 'RUNNING',
  PENDING = 'PENDING',
  FINISHED = 'FINISHED',
  NOT_CONCLUSIVE = 'NOT_CONCLUSIVE',
  NOT_START_LAST_12H = 'NOT_START_LAST_12H',
  FAILED = 'FAILED',
}
